import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import AirportInterface from '../../interfaces/client/Airport'
import FlightInterface from '../../interfaces/client/Flight'

import parseFlightId from '../../utils/parseFlightId'
import getFlightSeatCount from '../../utils/flights/getFlightSeatCount'

import FlightMetaData from '../../components/FlightMetaData'

interface FlightMetaDataPropsInterface {
  flightId: string
  showPassengers: boolean
}

// @TODO: get airport name from state after the airports store is normalized
const getAirportName = (
  airports: AirportInterface[] = [],
  airportId: string
) => {
  const airport = airports.find(airport => airport.id === airportId)
  return airport ? airport.name : airportId
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: FlightMetaDataPropsInterface
) => {
  const { flightId } = props
  const airports = state.v1airports.items

  const parsedFlightId = parseFlightId(flightId)
  const { date, number, arrival, departure } = parsedFlightId

  const departureAirportName = getAirportName(airports, departure)
  const arrivalAirportName = getAirportName(airports, arrival)
  const route = `${departureAirportName} - ${arrivalAirportName}`

  const flight: FlightInterface = state.flights.byId[flightId]
  const passengersCount = state.passengers.allIds.length

  if (!flight) {
    return {
      route,
      date,
      flightNumber: number,
      departureTime: '-',
      arrivalTime: '-',
      allotmentCount: 0,
      isFlightInformationAvailable: false,
      showPassengersCount: props.showPassengers,
      passengersCount,
    }
  }

  return {
    route,
    date,
    flightNumber: number,
    departureTime: flight.departureTime,
    arrivalTime: flight.arrivalTime,
    allotmentCount: getFlightSeatCount(flight.travelClassSeatCounts),
    isFlightInformationAvailable: true,
    showPassengersCount: props.showPassengers,
    passengersCount,
  }
}

export default connect(mapStateToProps)(FlightMetaData)
